import { render, staticRenderFns } from "./activeAccount.vue?vue&type=template&id=ccf66ada&scoped=true"
import script from "./activeAccount.vue?vue&type=script&lang=js"
export * from "./activeAccount.vue?vue&type=script&lang=js"
import style0 from "./activeAccount.vue?vue&type=style&index=0&id=ccf66ada&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf66ada",
  null
  
)

export default component.exports